import { isObjectDeeplyChanged } from '../../util/state';
import { State } from './index';

export const getUpdateFlags = (state: State, oldState: State) => {
    const { avcResult, selectedTariff, isBackendDown, homesPassed } = state;
    const avcChanged = isObjectDeeplyChanged(avcResult, oldState.avcResult);
    const tariffChanged = selectedTariff && isObjectDeeplyChanged(selectedTariff, oldState.selectedTariff);
    const errorChanged = isBackendDown !== oldState.isBackendDown;
    const homesPassedChanged = homesPassed !== oldState.homesPassed;

    return {
        offerSummaryCard: tariffChanged || avcChanged || homesPassedChanged,
        discount: tariffChanged,
        error: errorChanged,
    };
};
